<template>
  <div class="pageContain">
    <div @click="fristCurrent(item)" class="row right-border">
      {{ firstTitle }}
    </div>
    <div @click="upCurrent(item)" class="row right-border">{{ upTitle }}</div>
    <div class="midClass">
      <div
        @click="handleCurrent(item)"
        class="item right-border"
        :class="[chooseIndex == item ? 'active' : '']"
        v-for="(item, index) in pageArr"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
    <div @click="downCurrent(item)" class="row">{{ downTitle }}</div>
    <div @click="endCurrent(item)" class="row  left-border">{{ endTitle }}</div>
  </div>
</template>

<script>
export default {
  name: "ZhiniPagination",
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    totalPage: {
      type: Number,
      default: 12
    },
    showPage: {
      type: Number,
      default: 3
    },
    firstTitle: {
      type: String,
      default: "首页"
    },
    endTitle: {
      type: String,
      default: "尾页"
    },
    upTitle: {
      type: String,
      default: "上一页"
    },
    downTitle: {
      type: String,
      default: "下一页"
    }
  },
  data() {
    return {
      chooseIndex:Number(this.currentPage),
      item: 0,
      pageArr:[]
    };
  },
  watch:{ 
    currentPage:function(newVal){ 
      this.chooseIndex=Number(newVal);
    },
    totalPage:function(newVal){ 
      this.pageArr=this.pageArrFn()
    },
  },

  methods: {
    pageArrFn(){ 
      var totalPage = this.totalPage; //总页码
      var currentPage = this.currentPage; //当前页码
      var pageArr = []; //初始化页码数组
      var showPage = this.showPage; //指的是在...和...之间所有的方块div的数目

      //1. 当最大页码 小于 showPage时
      if (totalPage <= showPage) {
        for (let x = 1; x <= totalPage; x++) {
          pageArr.push(x);
        }

        return pageArr;
      }

      // 2. 当最大页码 大于 showPage时

      if (totalPage > showPage) {
        var leftArr = [];
        var isEven = showPage % 2;
        var rightArr = [];
        var midArr = [];
        // showPage 为奇数时

        var startNum = 1;
        var endNum = 0;
        var flagNum = isEven ? (showPage - 1) / 2 : showPage / 2;
        if (currentPage - flagNum > 2) {
          leftArr.push(1);
          leftArr.push("...");
          startNum = currentPage - flagNum;
        }

        endNum = currentPage + flagNum;
        if (endNum > totalPage - 2) {
          endNum = totalPage;
        }

        if (endNum <= totalPage - 2) {
          rightArr.push("...");
          rightArr.push(totalPage);
        }

        for (let x = startNum; x <= endNum; x++) {
          midArr.push(x);
        }

        pageArr = leftArr.concat(midArr, rightArr);
      }
      console.log(111,pageArr)
      return pageArr
    },
    handleCurrent(item) {
      console.log(111);

      if (item == "...") {
        return;
      }

      this.chooseIndex = item;
      // this.currentPage = item;
      this.$emit("pageNum", item);
      this.$emit("update:currentPage", item);
    },
    fristCurrent() {
      this.handleCurrent(1);
    },
    endCurrent() {
      this.handleCurrent(this.totalPage);
    },
    upCurrent() {
      if (this.currentPage == 1) {
        return;
      }
      this.handleCurrent(this.currentPage - 1);
    },
    downCurrent() {
      if (this.currentPage == this.totalPage) {
        return;
      }
      this.handleCurrent(this.currentPage + 1);
    }
  }
};
</script>

<style scoped>
.pageContain {
  /* display: flex; */
  width: 100%;
  /* justify-content: center; */
  /* background-color: #ffffff; */
  padding: 36px 0 26px;
  text-align: center;
}
.pageContain:hover {
  cursor: pointer;
}
.pageContain > div {
  display: inline-block;
}
.midClass {
  /* display: flex; */
}
.row {
  font-size:12px;
  text-align: center;
  line-height: 28px;
  height: 28px;
  margin: 0 7px;
  border: 1px solid #c1c1c1;
  padding: 0 14px;
}
.left-border {
  /* border-left: none !important; */
}
.right-border {
  /* border-right: none !important; */
}
.item {
  width: auto;
  padding: 0 14px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border:1px solid #c1c1c1;
  font-size:14px;
  border-radius:4px;
  margin: 0 7px;
  margin-bottom: 10px;
  display: inline-block;
}
.active {
  background: rgba(230, 31, 38, 1);
  color: #ffffff;
  border: none;
}
</style>
